<template>
  <div>
    <!-- <p>任务机翻详情传过来的id：{{renwuid}}</p> -->
    <p class="desc-info">
      <span>订单号：{{ flowInfo.orderId }}</span>
      <span>任务类型：打标</span>
      <span>当前任务状态：{{ flowInfo.status === -2?'进行中':this.$flowStatus.get(flowInfo.status) }}</span>
      <span>语种方向：{{ $sysLan.get(slan) }}-{{ $sysLan.get(tlan) }}</span>
      <!-- <router-link :to="{path:'/dot/order/detail/'+flowInfo.orderId}" style="margin-right:10px"> -->
        <el-button type="primary" icon="el-icon-document" size="mini" class="m-r-10" @click="toOrderDetail" plain>订单详情</el-button>
      <!-- </router-link> -->

      <el-popover
        v-if="this.showCreatePe"
        placement="top-start"
        width="310"
        trigger="hover"
        title="机翻结果不错？那就进入PE环节吧！"
        content=" PE是译员在机翻结果基础上进行译后编辑，将采用大量译员在线分布式翻译方式。可快速低价的完成翻译任务。">
        <el-button type="primary" size="mini" slot="reference" :loading="loading" @click.stop="preCheckPeDialogVisible()">创建PE任务
        </el-button>
      </el-popover>
      <el-button size="mini" type="warning" v-if="(flowInfo.status === 3 || this.flowInfo.status === -2) && permissions.dot_flow_submit"
                 @click.stop="endMission() ">结束打标任务
      </el-button>

    </p>
    <el-tabs type="card" v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="打标配置" name="1">
        <dbConfigure v-if="flowInfo.orderId" :status="flowInfo.status" :orderId="flowInfo.orderId" :configInfo="configInfo" ref="dbConfigure"/>
      </el-tab-pane>
      <el-tab-pane v-if="flowInfo.status === 3 || flowInfo.status === 4 || this.flowInfo.status === -2" name="2" label="数据统计">
        <dbStatistics :flowStatus="flowInfo.status" :orderId="flowInfo.orderId" ref="dbStatistics"></dbStatistics>
      </el-tab-pane>
      <el-tab-pane v-if="flowInfo.status === 3 || flowInfo.status === 4 || this.flowInfo.status === -2" name="3" label="任务管理">
        <dbManage :orderId="flowInfo.orderId" :staParams="staParams" ref="dbManage"></dbManage>
      </el-tab-pane>
    </el-tabs>

    <el-dialog :close-on-click-modal="false" title="创建PE任务" :visible.sync="peDialogVisible">
      <el-form :model="peForm">
        <el-form-item label="" label-width="20px">
          <p>请选择PE标准</p>
          <el-radio v-model="peForm.type" label="3" disabled>PE+快审（快速交付，审核比例较低）</el-radio>
          <br>
          <el-radio v-model="peForm.type" label="4" >PE+标审（标准审核，大多数项目的选择）</el-radio>
          <br>
          <el-radio v-model="peForm.type" label="5">PE+全审（全部审核，适用于对质量要求较高的项目）</el-radio>
        </el-form-item>
        <el-form-item label="" label-width="20px">
          <p>是否需要质控<span style="color:#F56C6C" v-if="isNeedQc">（您的项目较大，质控环节为必选）</span></p>
          <el-radio v-model="peForm.needQc" :disabled="isNeedQc" label="2">是</el-radio>
          <el-radio v-model="peForm.needQc" :disabled="isNeedQc" label="1">否</el-radio>
          <p>质控是在PE过程中介入，帮助把控项目总体质量的角色</p>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="peDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitCreatePe()">确定创建</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import dbConfigure from './marking-configure'
import dbStatistics from './marking-statistics'
import dbManage from './marking-manage'
import {getFlowInfo, addPeFlow, statistics} from '@/api/dot/flow'
import {check, finish} from '@/api/dot/marking'
import {countWords,getObj} from '@/api/dot/order'
import { mapGetters, mapState } from "vuex";
import {alertErroMsg, alertSuccessMsg,alertCommon} from "@/util/commonMsg";

export default {
  components: {dbConfigure, dbStatistics, dbManage},
  data() {
    return {
      activeName: "1",
      flowInfo: {},
      configInfo: {},
      slan:"",
      tlan:"",
      page: false,
      loading: false,
      isNeedQc: false,
      peDialogVisible: false,
      showCreatePe: false,
      peForm: {
        type: "4",
        needQc: "2"
      },
      staParams: null,
    }
  },
  computed: {
    ...mapGetters(['permissions']),
    ...mapState({
      userInfo: state => state.user.userInfo
    }),
  },
  created: function () {
    this.flowInfo = {}
    this.configInfo = {}
    getFlowInfo(this.$route.params.id).then(response => {
      this.flowInfo = response.data.data
      getObj(this.flowInfo.orderId).then(res=>{
        this.slan = res.data.data.slan;
        this.tlan = res.data.data.tlan;
      })
      let tempConfig = this.flowInfo
      if (this.flowInfo.configInfo) {
        tempConfig = JSON.parse(this.flowInfo.configInfo)
        tempConfig.limitTime = this.flowInfo.limitTime
        if (tempConfig.markingOptions) {
          tempConfig.markingOptions = tempConfig.markingOptions.split(",")
        }
        tempConfig.remark = this.flowInfo.remark
      }
      tempConfig.isConfigDisabled = this.flowInfo.status !== 1
      tempConfig.isRemarkDisabled = this.flowInfo.status === 4 || this.flowInfo.status === -1
      if (this.flowInfo.status === 1) {
        tempConfig.markingOptions = ["2", "3", "4", "5"]
        tempConfig.remark = "1.轻任务打标模式是一种分布式的在线打标方式，是指将一份大型稿件通过AI拆分成多个任务包，由若干译员分别在原有翻译结果的基础上进行译文准确度的结果标注，再由AI合稿的打标模式；\n" +
          "2.为使术语统一，页面上可能会有相应的术语提示，请按规定使用术语判断译文结果。\n" +
          "3.任务包提交后必须通过审核后方可计入预计收益，当整个众包任务订单被下单人确认后，预计收益计入可结算收益，待账期结束后，收益可自动入账并可提现；\n" +
          "4.对于恶意破坏平台正常任务派发交付的行为，将按照语翼12分规则进行处罚。"
      }
      this.configInfo = tempConfig
    })
  },
  beforeRouteEnter(to, from, next) {
    next(vm=>{
      vm.curPath = to.path;
      vm.oldPath = from.path;
    })
	},
  mounted() {
    this.staParams = {
      u_id: this.userInfo.staffId,
      time: new Date().getTime(),
      browser: navigator.userAgent.toLowerCase(),
      url: this.curPath,
      ref_url: this.oldPath,
      scene_name: '打标任务详情'
    }
    this.statistics()
  },
  methods: {
    statistics() {
      statistics(Object.assign({
        event_type: 'view'
      }, this.staParams))
    },

    toOrderDetail() {
      this.$router.push({path:'/dot/order/detail/'+this.flowInfo.orderId});
      statistics(Object.assign({
        event_name: '订单详情',
        event_type: 'click',
      }, this.staParams))
    },

    handleClick(tab, event) {
      if (tab.name === "2") {
        this.$refs.dbStatistics.init();
      } else if (tab.name === "3") {
        this.$refs.dbManage.getPage(this.$refs.dbManage.page, this.$refs.dbManage.searchForm)
      }
    },
    preCheckPeDialogVisible() {
      countWords(this.flowInfo.orderId).then(res => {
        this.isNeedQc = parseFloat(res.data.data.wordCount) > 50000;
      })
      this.peDialogVisible = true
    },
    //创建PE任务
    submitCreatePe() {
      this.loading = true
      addPeFlow({
        flowId: this.$route.params.id,
        orderId: this.flowInfo.orderId,
        type: this.peForm.type,
        needQc: this.peForm.needQc
      }).then(res => {
        this.peDialogVisible = false
        if (res.data.data === 1) {
          alertSuccessMsg();
        } else if (res.data.data === 2) {
          this.$alert(`添加成功，请前往配置PE任务`, {
            confirmButtonText: '确定',
            callback: action => {
              if (action === 'confirm') {
                this.$router.replace('/refresh')
                setTimeout(() => {
                  this.$router.push({path: '/dot/flow/detail-pe/' + res.data.msg})
                }, 500)
              } else {
                this.$router.replace('/refresh')
              }
            },
          });
        } else {
          alertErroMsg()
        }
        statistics(Object.assign({
          event_type: 'click',
          event_name: '创建PE任务',
          class_name: 'addPeFlow',
          class_url: '/dotadmin/dotadmin/flow/addPeFlow',
          event_params: '{flowId: this.$route.params.id, orderId: this.flowInfo.orderId, type: this.peForm.type, needQc: this.peForm.needQc}'
        }, this.staParams))
      })
    },
    //
    endMission() {
      let _this = this;
      //1.提交前的检查
      check(_this.$route.params.id).then(res => {
        if (res.data.data <= 0) {
          alertErroMsg()
        } else if (res.data.data === 1) {  //检测通过
          //结束打标
          this.$alert(`是否立刻结束任务？`, {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            closeOnClickModal:true,
            showCancelButton: true,
            callback: action => {
              if (action === 'confirm') {
                this.finishMark()
              } else {
                _this.$router.replace('/refresh')
              }

            },
          });
        } else if (res.data.data === 2) { //有进行中的任务
          this.$alert(`还有进行中的任务，强制结束任务可能会造成译员损失，是否立刻结束任务？`, {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            closeOnClickModal:true,
            showCancelButton: true,
            callback: action => {
              if (action === 'confirm') {
                //结束打标
                this.finishMark()
              } else {
                _this.$router.replace('/refresh')
              }

            },
          });
        }
      })
      statistics(Object.assign({
        event_type: 'click',
        event_name: '结束打标任务',
        class_name: 'finish',
        class_url: '/dotadmin/dotadmin/marking/finish/',
        event_params: '{flowId: this.$route.params.id, orderId: this.flowInfo.orderId}'
      }, this.staParams))
    },

    finishMark() {
      finish(this.$route.params.id, this.flowInfo.orderId).then(res => {
        if (res.data.data === 1) {
          alertSuccessMsg();
        } else if (res.data.data === 2) {
          this.$alert(`打标任务已完成，您还有PE任务待配置，请前往配置`, {
            confirmButtonText: '前往配置',
            closeOnClickModal:true,
            callback: action => {

              if (action === 'confirm') {
                this.$router.replace('/refresh')
                setTimeout(() => {
                  this.$router.push({path: '/dot/flow/detail-pe/' + res.data.msg})
                }, 500)
              } else {
                this.$router.replace('/refresh')
              }

            },
          });
        } else {
          alertErroMsg()
        }

      })
    },
  },
  filters: {},
}

</script>
<style lang="scss" scoped>
.avue-view {
  background: #FFFFFF;
  padding: 20px;
  min-height: calc(100vh - 100px);
}

.desc-info {
  width: 100%;
  padding-left: 0;

  > span {
    margin-right: 50px;
  }
}

</style>
